export const {
  VITE_APP_SERVER,
  VITE_APP_SENTRY_DSN,
  VITE_APP_PAYPAL_ENVIRONMENT,
  VITE_APP_GTM_CONTAINER,
  VITE_APP_INTERCOM_APP_ID,
  VITE_APP_RE_CAPTCHA_SITE_KEY,
  VITE_APP_PAYPAL_CLIENT_KEY_SANDBOX,
  VITE_APP_TIKTOK_AUTH_API,
  VITE_APP_SOCKET_URL,
  VITE_APP_TIKTOK_SERVER,
  VITE_APP_GA_CONTAINER,
  VITE_APP_REACH_STEP_BUDGET_TIKTOK_CAMPAIGN,
  VITE_APP_GROWTHBOOK_API_HOST,
  VITE_APP_GROWTHBOOK_CLIENT_KEY,
  VITE_APP_IS_PAYPAL_TRANSACTIONS_ENABLED,
  VITE_APP_DATE_IS_NEW_USER_REMOVE_APROVALL_STEP,
  VITE_APP_ENABLED_DEV_MODE_GROWTHBOOK,
  VITE_APP_SOURCEBUSTER_DOMAIN,
  VITE_APP_DATE_IS_NEW_USER_CHECKOUT_TIMER,
  VITE_APP_DATE_IS_NEW_USER_REMOVE_PAYPAL_EXP,
  VITE_APP_DATE_IS_NEW_CURATOR_BONUS_SYSTEM,
  VITE_APP_DATE_IS_NEW_ARTIST_LOW_REACH,
  VITE_APP_DATE_IS_NEW_ARTIST_SIMILAR_ARTISTS,
  VITE_APP_DATE_IS_NEW_BUDGET_RANGE_EXPERIMENT,
  VITE_APP_DATE_IS_OLD_FOR_REFER_UPSELL,
  VITE_APP_ENABLE_META_ADS,
  VITE_APP_DATE_IS_NEW_USER_TIKTOK_MIN_BUDGET_100_150_EXP,
  VITE_APP_DATE_IS_NEW_USER_SPOTIFY_MIN_BUDGET_60_80_EXP,
  VITE_APP_DATE_IS_NEW_USER_MANUAL_MATCHING_EXP,
  VITE_APP_DATE_IS_NEW_USER_MANUAL_MATCHING_V2_EXP,
  VITE_APP_DATE_IS_NEW_USER_THRESHOLD_COUPON_EXP,
  VITE_APP_MANUAL_MATCHING_ENABLED,
  VITE_APP_DATE_IS_NEW_USER_VIDEOS_BASED,
  VITE_APP_TIKTOK_VIDEOS_BASED_ENABLED,
  VITE_APP_NEW_WISE_PROCESS_ENABLED,
  VITE_APP_PRE_RELEASE_CAMPAIGNS_ENABLED,
  VITE_APP_PRE_RELEASE_NEW_LABEL_CUTOFF_DATE,
  VITE_APP_STRIPE_PUBLISHABLE_KEY,
} = import.meta.env as Record<string, string>

export const APP = {
  SERVER: VITE_APP_SERVER,
  SENTRY_DSN: VITE_APP_SENTRY_DSN,
  GTM_CONTAINER: VITE_APP_GTM_CONTAINER,
  INTERCOM_APP_ID: VITE_APP_INTERCOM_APP_ID,
  paypal_environment: VITE_APP_PAYPAL_ENVIRONMENT, // sandbox or production
  SOCKET_URL: VITE_APP_SOCKET_URL,
  PAYPAL_CLIENT_KEY_SANDBOX: VITE_APP_PAYPAL_CLIENT_KEY_SANDBOX,
  TIKTOK_SERVER: VITE_APP_TIKTOK_SERVER,
  TIKTOK_AUTH_API: VITE_APP_TIKTOK_AUTH_API,
  IS_PAYPAL_TRANSACTIONS_ENABLED:
    VITE_APP_IS_PAYPAL_TRANSACTIONS_ENABLED === 'true',
  ENABLED_DEV_MODE_GROWTHBOOK: VITE_APP_ENABLED_DEV_MODE_GROWTHBOOK === 'true',
  GA_CONTAINER: VITE_APP_GA_CONTAINER,
  RE_CAPTCHA_SITE_KEY: VITE_APP_RE_CAPTCHA_SITE_KEY,
  GROWTHBOOK_API_HOST: VITE_APP_GROWTHBOOK_API_HOST,
  GROWTHBOOK_CLIENT_KEY: VITE_APP_GROWTHBOOK_CLIENT_KEY,
  REACH_STEP_BUDGET_TIKTOK_CAMPAIGN: Number(
    VITE_APP_REACH_STEP_BUDGET_TIKTOK_CAMPAIGN,
  ),
  SOURCEBUSTER_DOMAIN: VITE_APP_SOURCEBUSTER_DOMAIN,
  DATE_IS_NEW_USER_REMOVE_APROVALL_STEP:
    VITE_APP_DATE_IS_NEW_USER_REMOVE_APROVALL_STEP,
  DATE_IS_NEW_USER_CHECKOUT_TIMER: VITE_APP_DATE_IS_NEW_USER_CHECKOUT_TIMER,
  DATE_IS_NEW_USER_REMOVE_PAYPAL_EXP:
    VITE_APP_DATE_IS_NEW_USER_REMOVE_PAYPAL_EXP,
  DATE_IS_NEW_CURATOR_BONUS_SYSTEM: VITE_APP_DATE_IS_NEW_CURATOR_BONUS_SYSTEM,
  DATE_IS_NEW_ARTIST_LOW_REACH: VITE_APP_DATE_IS_NEW_ARTIST_LOW_REACH,
  DATE_IS_NEW_BUDGET_RANGE_EXPERIMENT:
    VITE_APP_DATE_IS_NEW_BUDGET_RANGE_EXPERIMENT,
  DATE_IS_OLD_FOR_REFER_UPSELL: VITE_APP_DATE_IS_OLD_FOR_REFER_UPSELL,
  ENABLE_META_ADS: VITE_APP_ENABLE_META_ADS === 'true',
  DATE_IS_NEW_USER_TIKTOK_MIN_BUDGET_100_150_EXP:
    VITE_APP_DATE_IS_NEW_USER_TIKTOK_MIN_BUDGET_100_150_EXP,
  DATE_IS_NEW_USER_SPOTIFY_MIN_BUDGET_60_80_EXP:
    VITE_APP_DATE_IS_NEW_USER_SPOTIFY_MIN_BUDGET_60_80_EXP,
  DATE_IS_NEW_USER_MANUAL_MATCHING_EXP:
    VITE_APP_DATE_IS_NEW_USER_MANUAL_MATCHING_EXP,
  DATE_IS_NEW_USER_MANUAL_MATCHING_V2_EXP:
    VITE_APP_DATE_IS_NEW_USER_MANUAL_MATCHING_V2_EXP,
  DATE_IS_NEW_USER_THRESHOLD_COUPON_EXP:
    VITE_APP_DATE_IS_NEW_USER_THRESHOLD_COUPON_EXP,
  MANUAL_MATCHING_ENABLED: VITE_APP_MANUAL_MATCHING_ENABLED === 'true',
  DATE_IS_NEW_USER_VIDEOS_BASED: VITE_APP_DATE_IS_NEW_USER_VIDEOS_BASED,
  TIKTOK_VIDEOS_BASED_ENABLED: VITE_APP_TIKTOK_VIDEOS_BASED_ENABLED === 'true',
  NEW_WISE_PROCESS_ENABLED: VITE_APP_NEW_WISE_PROCESS_ENABLED === 'true',
  PRE_RELEASE_CAMPAIGNS_ENABLED:
    VITE_APP_PRE_RELEASE_CAMPAIGNS_ENABLED === 'true',
  PRE_RELEASE_NEW_LABEL_CUTOFF_DATE: VITE_APP_PRE_RELEASE_NEW_LABEL_CUTOFF_DATE,
  STRIPE_PUBLISHABLE_KEY: VITE_APP_STRIPE_PUBLISHABLE_KEY,
}
